/**
 * Get cities data based on COUNTRY environment variable
 * Reads from src/data/citieslist/{countryCode}.json
 * Falls back to src/data/cities.json if country file doesn't exist
 * 
 * For React: Uses static imports with switch statement (bundler-friendly)
 * For Node.js: Can use dynamic require
 */

import { COUNTRY_CODE_VALUE } from '../config/countryCode'

let citiesDataCache = null

const loadCitiesData = () => {
  if (citiesDataCache !== null) {
    return citiesDataCache
  }

  const countryCode = COUNTRY_CODE_VALUE || 'germany'
  
  // Use switch statement for static imports (works with bundlers)
  // This ensures the bundler knows which files to include
  try {
    let countryData
    switch (countryCode) {
      case 'austria':
        countryData = require('../data/citieslist/austria.json')
        break
      case 'australia':
        countryData = require('../data/citieslist/australia.json')
        break
      case 'belgium':
        countryData = require('../data/citieslist/belgium.json')
        break
      case 'canada':
        countryData = require('../data/citieslist/canada.json')
        break
      case 'switzerland':
        countryData = require('../data/citieslist/switzerland.json')
        break
      case 'czech':
        countryData = require('../data/citieslist/czech.json')
        break
      case 'germany':
        countryData = require('../data/citieslist/germany.json')
        break
      case 'denmark':
        countryData = require('../data/citieslist/denmark.json')
        break
      case 'spain':
        countryData = require('../data/citieslist/spain.json')
        break
      case 'finland':
        countryData = require('../data/citieslist/finland.json')
        break
      case 'france':
        countryData = require('../data/citieslist/france.json')
        break
      case 'uk':
        countryData = require('../data/citieslist/uk.json')
        break
      case 'ireland':
        countryData = require('../data/citieslist/ireland.json')
        break
      case 'israel':
        countryData = require('../data/citieslist/israel.json')
        break
      case 'italy':
        countryData = require('../data/citieslist/italy.json')
        break
      case 'netherlands':
        countryData = require('../data/citieslist/netherlands.json')
        break
      case 'norway':
        countryData = require('../data/citieslist/norway.json')
        break
      case 'new zealand':
      case 'newzealand':
        countryData = require('../data/citieslist/newzealand.json')
        break
      case 'poland':
        countryData = require('../data/citieslist/poland.json')
        break
      case 'sweden':
        countryData = require('../data/citieslist/sweden.json')
        break
      case 'slovakia':
        countryData = require('../data/citieslist/slovakia.json')
        break
      case 'usa':
        countryData = require('../data/citieslist/usa.json')
        break
      default:
        // For unknown countries, try dynamic require (Node.js) or fallback
        try {
          countryData = require(`../data/citieslist/${countryCode}.json`)
        } catch (dynamicError) {
          throw new Error(`Country file not found: ${countryCode}`)
        }
    }
    citiesDataCache = countryData.default || countryData
    return citiesDataCache
  } catch (error) {
    // Fallback to cities.json if country file doesn't exist
    try {
      const fallbackData = require('../data/cities.json')
      citiesDataCache = fallbackData.default || fallbackData
      console.warn(`Country file citieslist/${countryCode}.json not found, using cities.json`)
      return citiesDataCache
    } catch (fallbackError) {
      console.error('Error loading cities data:', fallbackError)
      return []
    }
  }
}

// Export the function
export const getCitiesData = loadCitiesData

// Default export for backward compatibility (synchronous, called immediately)
export default loadCitiesData()
